import { CommunitiesListLoadingPlaceholderListItems } from 'modules/communities/list/components/CommunitiesListItems/CommunitiesListLoadingPlaceholderListItems';
import { ListLayout } from '../../list/components/ListLayout';
import { ListSidebarIndicatorButton } from '../../list/components/ListSidebar/ListSidebarIndicatorButton';

function PublicNewsListLoadingPlaceholder() {
	return (
		<ListLayout>
			<CommunitiesListLoadingPlaceholderListItems
				skipCommentsCount
				skipMembersCount
				skipNewsCount
				hasLinkButton
			/>
			<ListSidebarIndicatorButton disabled />
		</ListLayout>
	);
}

export { PublicNewsListLoadingPlaceholder };
